import React from 'react';
import PropTypes from 'prop-types';

import ImportsRow from './imports_row';

export default function ImportsTable({ imports }) {
  return (
    <div className="table-responsive">
      <table className="table table-hover border-clear m-0 table-fixed">
        <thead>
          <tr>
            <th>Name</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {imports.map(importObject => (<ImportsRow importObject={importObject} key={importObject.id} />))}
        </tbody>
      </table>
    </div>
  );
}

ImportsTable.propTypes = {
  imports: PropTypes.array
};
